module.exports = __webpack_public_path__ + "static/img/6269_phase_function_Paper_PointsHejduk_Prediction.965ee28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6269_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7TNx
// module chunks = 0